<template>
    <div style="margin-bottom:0px" class="card col-lg-12 ml-auto mr-auto" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
        <div class="card-body">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="modal-header">

                            <h5 class="modal-title DayHeading" id="myModalLabel"> {{ $t('RackBarcodeCreate.RacksBarcode') }}</h5>

                        </div>

                        <div>
                            <div class="card-body">
                                <div class="row ">

                                    <div class="col-sm-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                        <label>{{ $t('RackBarcodeCreate.SelectCategory') }} :<span class="LabelColour"> *</span></label>
                                        <div v-bind:class="{'has-danger' : $v.racksBarcode.categoryId.$error}">
                                            <categorydropdown v-model="$v.racksBarcode.categoryId.$model" v-on:input="getProductList"></categorydropdown>
                                            <span v-if="$v.racksBarcode.categoryId.$error" class="error text-danger">
                                                <span v-if="!$v.racksBarcode.categoryId.required">{{$t('RackBarcodeCreate.CategoryRequired')}}</span>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group has-label col-sm-6 " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage mt-2'">
                                        <label class="text  font-weight-bolder"> {{ $t('RackBarcodeCreate.PrintPerProduct') }}: </label>
                                        <input class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-model="racksBarcode.totalPrintPerProduct" type="number" />

                                    </div>
                                    <div class="col-sm-12" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                        <label>{{ $t('RackBarcodeCreate.PleaseSelectProduct') }} :<span class="LabelColour"> *</span></label>
                                        <div>
                                            <productMultiSelectDropdown v-model="racksBarcode.productIdList" :key="render" v-bind:values="racksBarcode.productIdList" :categoryId="racksBarcode.categoryId" :isRequest="isRequest"></productMultiSelectDropdown>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div v-if="racksBarcode.productIdList.length > 0" class=" float-right">


                            <button type="button" class="btn btn-primary  " v-on:click="RackBarCodePrintBtn" v-bind:disabled="$v.racksBarcode.$invalid"> {{ $t('RackBarcodeCreate.Print') }}</button>
                            <router-link :to="'/StartScreen'"><a href="javascript:void(0)" class="btn btn-outline-danger "> {{ $t('RackBarcodeCreate.Close') }}</a></router-link>

                        </div>
                        <div v-else class=" float-right">
                            <button type="button" class="btn btn-primary  " v-on:click="RackBarCodePrintBtn" disabled> {{ $t('RackBarcodeCreate.Print') }}</button>
                            <router-link :to="'/BarcodeSetup'"><a href="javascript:void(0)" class="btn btn-outline-danger  "> {{ $t('RackBarcodeCreate.Close') }}</a></router-link>

                        </div>
                        <!--<div v-if="!loading">

                            <div class="modal-footer justify-content-right" v-if="type=='Edit' && isValid('Can Edit SubCategories')">
                                <button type="button" class="btn btn-primary  " v-on:click="SaveSubCategory" v-bind:disabled="$v.subCategory.$invalid"> {{ $t('btnUpdate') }}</button>
                                <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('btnClear') }}</button>
                            </div>
                            <div class="modal-footer justify-content-right" v-if="type!='Edit' && isValid('Can Save SubCategories')">
                                <button type="button" class="btn btn-primary  " v-on:click="SaveSubCategory" v-bind:disabled="$v.subCategory.$invalid"> {{ $t('btnSave') }}</button>
                                <button type="button" class="btn btn-danger  mr-3 " v-on:click="close()">{{ $t('btnClear') }}</button>
                            </div>
                        </div>
                        <div v-else>
                            <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
        <rack-barcode-print :printDetails="totalProductList" :image="image" :key="printRender" :printPerLine="racksBarcode.totalPrintPerProduct"></rack-barcode-print>
    </div>
    <!--<acessdenied v-else :model=true></acessdenied>-->
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import { required } from "vuelidate/lib/validators"
    //import Loading from 'vue-loading-overlay';
    //import 'vue-loading-overlay/dist/vue-loading.css';
    export default ({
        mixins: [clickMixin],
        name: 'RacksBarcodePrint',
        //components: {
        //    Loading
        //},
        data: function () {

            return {
                loading: false,
                arabic: '',
                english: '',
                render: 0,
                options: [],
                isRequest: false,
                racksBarcode: {
                    categoryId: '',
                    productIdList: [],
                    totalPrintPerProduct: 1
                },
                totalProductList: [],
                printRender: 0,
                image: ''
            }
        },
        validations: {
            racksBarcode:
            {

                categoryId: {
                    required
                }
            }
        },
        methods: {
            getBase64Image: function (path) {

                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https
                    .get('/Contact/GetBaseImage?filePath=' + path, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                        if (response.data != null) {

                            root.image = response.data;



                        }
                    });
            },
            GetCompanyDetails: function (Id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.headerFooter.company.logoPath = 'data:image/png;base64,' + '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';

                this.$https.get('/Company/EditCompany?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {


                        if (response.data.logoPath != null) {
                            root.getBase64Image(response.data.logoPath);
                        }


                    }
                });
            },
            RackBarCodePrintBtn: function () {
                var root = this;
                root.totalProductList = [];

                root.racksBarcode.productIdList.forEach(function (x) {
                    for (let i = 0; i < root.racksBarcode.totalPrintPerProduct; i++) {

                        root.totalProductList.push(x);
                    }

                })

                //alert(root.totalProductList);
                this.printRender++;

            },
            getProductList: function () {

                this.isRequest = true;
                this.render++;

            },
            SaveSubCategory: function () {
                var root = this;
                this.loading = true;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.post('/Product/SaveSubCategoryInformation', this.subCategory, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.isSuccess == true) {

                            if (root.type != "Edit") {
                                root.$swal({
                                    icon: 'success',
                                    title: 'Saved Successfully!',
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                });

                                root.close();
                            }
                            else {
                                root.$swal({
                                    title: "Update!",
                                    icon: 'success',
                                    text: "Update Successfully!",
                                    type: 'success',
                                    showConfirmButton: false,
                                    timer: 1500,
                                    timerProgressBar: true,
                                });
                                root.close();
                            }
                        }
                        else {
                            root.$swal({
                                title: "Error!",
                                icon: 'error',
                                text: "Your Sub Category Already Exist!",
                                type: 'error',
                                confirmButtonClass: "btn btn-danger",
                                showConfirmButton: false,
                                timer: 1500,
                                timerProgressBar: true,
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Something Went Wrong!',
                                text: error.response.data,

                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false
                    })
                    .finally(() => root.loading = false);
            },

        },
        created() {
            this.$emit('input', this.$route.name);
        },

        mounted: function () {
            var companyId = localStorage.getItem('CompanyID');
            this.GetCompanyDetails(companyId);
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');

        }
    })

</script>